export default function calcScrollbarWidth() {
    // Вычисление толщины скроллбара браузера
    setTimeout(() => {
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll";
        outer.style.msOverflowStyle = "scrollbar";
        document.body.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);

        document.documentElement.style.setProperty(
            "--scrollbar-width",
            scrollbarWidth + "px"
        );
    }, 50);
}
